var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetProfileDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pet_profile_delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.31,
    y: 0.46,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.31,
    y: 0.46,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "delete_profile",
    "data-name": "delete profile"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 299.63,
    fill: "#ff7e74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74,216.31H432.21a0,0,0,0,1,0,0V483.5a15,15,0,0,1-15,15H179.74a15,15,0,0,1-15-15V216.31A0,0,0,0,1,164.74,216.31Z",
    fill: "#ffe9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.48,
    y: 150.68,
    width: 346.07,
    height: 65.63,
    rx: 32.25,
    fill: "#ffe9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.08,
    y: 113,
    width: 82.89,
    height: 75.36,
    rx: 34.24,
    fill: "#ffe9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.57,
    y: 282.1,
    width: 33.58,
    height: 173.87,
    rx: 16.5,
    fill: "#ff7e74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.73,
    y: 282.1,
    width: 33.58,
    height: 173.87,
    rx: 16.5,
    fill: "#ff7e74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.89,
    y: 282.1,
    width: 33.58,
    height: 173.87,
    rx: 16.5,
    fill: "#ff7e74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.12,
    y: 216.12,
    width: 302.93,
    height: 20.35,
    fill: "#ff7e74"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileDelete);
export default __webpack_public_path__ + "static/media/pet_profile_delete.67aac87fe022a097b5547198705010b6.svg";
export { ForwardRef as ReactComponent };